// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const chartWrapper = "CreditSummaryModule__chartWrapper__3AzNc";
export const creditSummaryModule = "CreditSummaryModule__creditSummaryModule__tCTnj";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const label = "CreditSummaryModule__label__v07BL";
export const linkCreditButtonWrapper = "CreditSummaryModule__linkCreditButtonWrapper__Brtqe";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";